export class UniversalListSettings {
    constructor( public moduleName: string, public tableName: string) {
        this.showTitle = true;
        this.showSearch = true;
        this.showFooter = true;
        this.emitOnClose = false;
        this.applyOneClick = false;
        this.changeSizes = false;
        this.startWidth = 260;
        this.startHeight = 400;
        this.minWidth = 200;
        this.minHeight = 300;
        this.maxWidth = 640;
        this.maxHeight = 640;
        this.showSelectedList = false;
        this.showItemsInfo = true;
        this.cloneIncomingData = true;
        this.frozenColumnsNum = 0;
        this.hideListenerOnDom = true;
        this.selectAllField = 'code';
        this.popper = { placement: 'bottom-start', behavior: ['bottom', 'bottom-end'] };
        this.denyFilters = false;
        this.openSelectedList = false;
        this.disableOkNoneSelected = false;
    }

    public showTitle: boolean;
    public showSearch: boolean;
    public showFooter: boolean;
    public emitOnClose: boolean;
    public applyOneClick: boolean;
    public changeSizes: boolean;
    public startWidth: number;
    public startHeight: number;
    public minWidth: number;
    public minHeight: number;
    public maxWidth: number;
    public maxHeight: number;
    public showSelectedList: boolean;
    public showItemsInfo: boolean;
    public cloneIncomingData: boolean;
    public frozenColumnsNum: number;
    public hideListenerOnDom: boolean;
    public selectAllField: string;
    public popper: { placement: string, behavior: string[] };
    public denyFilters: boolean;
    public openSelectedList: boolean;
    public disableOkNoneSelected: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/universal-list.ts